class Store extends HTMLElement {
    constructor() {
      super();
      this.stores = window.Stores;
      this.name = this.querySelector('.store__name');
      this.content = this.querySelector('.store__content');
      this.image = document.querySelector('.store__image');
      this.dropdownToggleBtn = this.querySelector('.store__selectorToggle');
      this.dropdown = this.querySelector('.store__selectorDropdown');
      this.dropdownActive = false;

      this.dropdownToggleBtn.addEventListener('click', this.toggleDropdown.bind(this));
  
      this.querySelectorAll('.store__selectorValue').forEach(
        (button) => button.addEventListener('click', this.changeStore.bind(this))
      );
    }

    dropdownOpen() {
        this.dropdownActive = true;
        this.classList.add('dropdown');
    }

    dropdownClose() {
        this.dropdownActive = false;
        this.classList.remove('dropdown');
    }

    toggleDropdown(event) {
        event.preventDefault();

        if (this.dropdownActive) {
            this.dropdownClose();
        } else {
            this.dropdownOpen();
        }
    }
  
    changeStore(event) {
      event.preventDefault();
      
      const target = event.target.closest('button');
      const store_name = target.getAttribute('data-store');

      const store = Object.values(this.stores).find(v => {
          return v.title == store_name
      });

      const image_350 = store.image + '&width=350',
            image_750 = store.image + '&width=750',
            image_800 = store.image + '&width=800';

      const image = '<img srcset="'+ image_350 +' 350w, '+ image_750 +' 750w, '+ image_800 +' 800w" sizes="100vw" src="'+ store.image +'" loading="lazy" width="800" height="700" alt="'+ store.title +'">';

      this.name.innerHTML = store.title;
      this.content.innerHTML = store.content;
      this.image.innerHTML = image;

      this.dropdownClose();
    }
}

customElements.define('store-location', Store);